import { ElButton } from "element-plus";
export default {
  components: {
    ElButton
  },
  methods: {
    // 可以写入全局方法等
  }
};